var map = {
	"./android-icon.svg": 2173,
	"./app-img.png": 2174,
	"./app-qr-code-bg.png": 2175,
	"./apple-icon.svg": 2176,
	"./contact-bg.png": 2177,
	"./contact-us-bg.jpg": 2178,
	"./contact-us-main-bg.webp": 2179,
	"./qr-bg.png": 2180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2172;